// @flow
import { themeStyle } from '../colorPalettes'

import { darkTheme } from './darkTheme'

import type { ThemeType } from '..'

const futuretvThemeName = 'futuretv'

export const themeFuturetv: ThemeType = {
  name: futuretvThemeName,
  getThemeVariation: (themeVariation: string) => {
    switch (themeVariation) {
      case themeStyle.dark:
        return darkTheme
      default:
        return darkTheme
    }
  },
}
